import { call, put, takeLatest } from 'redux-saga/effects';
import JWT from 'jsonwebtoken';
import { EXTERNAL_INSTALLER, TECHNICIAN, VERIFY_TOKEN_REQUEST, START_DAY_REQUEST, } from '../constants';
import * as action from '../actions/verifyTokenActions';
import { fetchGrantedAuthorities } from 'modules/Authentication/api';
function verifyToken({ token }) {
    const ENVIRONMENT = process.env.ENVIRONMENT;
    const decodedToken = JWT.decode(token);
    if (decodedToken) {
        const expDate = new Date(0).setUTCSeconds(decodedToken.exp);
        const dateNow = new Date().getTime();
        if (ENVIRONMENT === 'development') {
            // eslint-disable-next-line no-console
            console.log('Token', token);
            // eslint-disable-next-line no-console
            console.log(`Decoded token:`, decodedToken);
        }
        return {
            isExpired: dateNow > expDate,
            token,
        };
    }
    return null;
}
function* callVerifyToken(token) {
    const result = yield call(verifyToken, token);
    const granedAuthorities = yield call(fetchGrantedAuthorities);
    const role = granedAuthorities.includes(TECHNICIAN) ? TECHNICIAN : EXTERNAL_INSTALLER;
    if (process.env.ENVIRONMENT === 'development') {
        // eslint-disable-next-line no-console
        console.log(`Granted Authorities:`, granedAuthorities);
        // eslint-disable-next-line no-console
        console.log(`Role:`, role);
    }
    if (!result.isExpired) {
        yield put(action.successTokenVerification({
            token: result.token,
            role: role,
        }));
        yield put({ type: START_DAY_REQUEST });
    }
    else {
        yield put(action.failureTokenVerification({
            errorMessage: 'Unauthorized',
        }));
    }
}
export default [takeLatest(VERIFY_TOKEN_REQUEST, callVerifyToken)];
